import { type RefObject, useEffect, useRef } from "react";

type HookParams = {
    onWheelEvent?: (e: WheelEvent) => void;
};

export const useOverwriteWheelEvent = ({ onWheelEvent }: HookParams = {}): RefObject<HTMLElement | null> => {
    const elementRef = useRef<HTMLElement>(null);

    useEffect(() => {
        const el = elementRef.current;
        if (!el) {
            return;
        }

        const handleWheel = (e: WheelEvent) => {
            e.stopPropagation();

            onWheelEvent?.(e);
        };

        el.addEventListener("wheel", handleWheel);

        return () => el.removeEventListener("wheel", handleWheel);
    }, [elementRef, onWheelEvent]);

    return elementRef;
};
